import React, { useState, useContext } from 'react';
import { GetData } from './Fetch';
import { TranslationContext, SettingsContext } from "./Context";
import Select from 'react-select';

function PlateNumberSearch(props) {

    const translation = useContext(TranslationContext);
    const settings = useContext(SettingsContext);
    const [plateNumber, setPlateNumber] = useState('');
    const createOptions = () => {
        const result = [];
        props.countries.map(x => {

            const option = {};
            option.value = x.Code;
            option.label = x.Name;
            option.icon = <img src={x.FlagUrl} className='heroPartsSearchComponent-dropdownFlag' />
            result.push(option);
        });
        return result;
    };
    const [countryOption, setCountryOption] = useState(createOptions().find(c => c.value === props.selectedCountry));

    function handlePlateNumberCountrySelection(e) {
        setCountryOption(e);
        setPlateNumber('');
        props.onVehicleSelected(null);
    }

    function handleChangePlateNumber(e) {
        const value = e.target.value.toUpperCase();
        setPlateNumber(value);
    }

    function handleSearchByPlateNumberSubmit(e) {
        e.preventDefault();
        GetData(`/language/${settings.language}/country/${countryOption.value}/platenumber/${plateNumber}`)
            .then(data => {
                props.onVehicleSelected(data[0]);
            });
    }



    const formatOptionLabel = ({ value, label, icon }) => (
        <div style={{ display: "" }}>
            {icon}{label}
        </div>
    );

    return (
        <div className="row u-mbottom30">
            <form onSubmit={handleSearchByPlateNumberSubmit}>
                <div className="col-md-6">
                    <div className="form-group">
                        <label className="u-textSemi16 u-block" htmlFor='country'>{translation["TecAlliencePartSearch.PartsSearch.Browse.Country"]} *</label>
                        <Select id='country' options={createOptions()} placeholder={<div>Type to search</div>}
                            value={countryOption}
                            noOptionsMessage={() => "nope..."}
                            onChange={handlePlateNumberCountrySelection} formatOptionLabel={formatOptionLabel} />
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="form-group">
                        <label className="u-textSemi16 u-block" htmlFor="plateNumber">{translation["TecAlliencePartSearch.PartsSearch.Browse.PlateNumber"]} *</label>
                        <input type="text" autoFocus className="form-control input-lg" onChange={handleChangePlateNumber} value={plateNumber} required />
                    </div>
                </div>

                <div className="col-xs-12">
                    <button className="d-block btn btn-primary u-width100" type="submit">{translation["TecAlliencePartSearch.PartsSearch.Browse.Search"]}</button>
                </div>

            </form>


        </div>
    );
}

export default PlateNumberSearch;